import { ref } from "vue"
import { toast } from "vue-sonner"

export function useDownloadReport(type: 'tickets' | 'sellers' | 'coupons', workshopId: number | null | undefined) {
  const isGenerating = ref(false)

  const handleDownload = async () => {
    isGenerating.value = true

    try {
      const workshopParam = workshopId ? `&workshop_id=${workshopId}` : ''
      const response = await fetch(`/admin/reports/download_pdf?type=${type}${workshopParam}`, {
        headers: {
          Accept: 'application/pdf',
        },
      })

      if (!response.ok) {
        throw new Error('Erro ao gerar PDF')
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = `relatorio-${new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      toast.error('Erro ao gerar PDF')
      console.error(err)
    } finally {
      isGenerating.value = false
    }
  }


  return {
    isGenerating,
    handleDownload,
  }
}